import { useEffect } from 'react';

const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

const config = {
  attributes: true,
  characterData: true,
  subtree: true,
  childList: true
};

export function useMutationObserver(ref, callback, options = config) {
  useEffect(() => {
    if (isIE11) return;
    // Create an observer instance linked to the callback function
    if (ref.current) {
      const observer = new MutationObserver(callback);
      // Start observing the target node for configured mutations
      observer.observe(ref.current, options);
      return () => {
        observer.disconnect();
      };
    }
  }, [callback, options, ref]);
}
